module.exports = __webpack_public_path__ + "static/mt-3c1b84c973a9ae883656001f61fe5a20.svg";